<!-- orderConfirmBottomButton -->
<template>
  <section class="bottomButton">
    <div class="pricePart">
      <p class="payable">
        <span class="text">应付</span>
        <span class="price">￥{{payable}}</span>
      </p>
      <p class="totalDiscount">
        <span class="text">总优惠</span>
        <span class="price">￥{{totalDiscount}}</span>
      </p>
    </div>
    <button class="submitButton" @click="goCashier" :class="{becomeGrey : orderCommitLoading}">提交订单</button>
  </section>
</template>

<script>
export default {
  props: {
    payable: {
      type: String,
      default: '0',
    },
    totalDiscount: {
      type: String,
      default: '0',
    },
    orderCommitLoading: { // 防止提交按钮重复点击
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goCashier() {
      if (this.orderCommitLoading) {
        return;
      }
      this.$emit('goCashier');
    },
  },
};

</script>

<style lang="scss" scoped>
.bottomButton {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  height: 120px;
  height: calc(120px + constant(safe-area-inset-bottom));
  height: calc(120px + env(safe-area-inset-bottom));
  padding: 36px;
  background: #FFF;

  .pricePart {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .payable,
    .totalDiscount {
      height: 40px;
      margin-right: 7px;
      font-size: 29px;
      line-height: 40px;

      span {
        color: #FF791B;
      }
    }

    .payable .text {
      margin-right: 7px;
      color: #333;
      font-weight: bold;
    }

    .totalDiscount .text {
      margin-right: 5px;
      color: #787878;
      font-size: 22px;
    }
    .totalDiscount .price {
      font-size: 22px;
    }
  }

  .submitButton {
    width: 236px;
    height: 82px;
    color: #FFF;
    font-weight: bold;
    font-size: 29px;
    background: #FF6C02;
    border-radius: 41px;

    &:active {
      background: #FF984D;
    }
  }
}
</style>
